import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import { SemanticUI } from '@iterable/deprecated_react_components';
import DragAndDropList from 'core/dragAndDropList';
import { Modal } from 'ui/modal';

// @ts-ignore
export const StyledCoreModal = styled(Modal)`
  &&& {
    .content {
      padding: ${pxToRem(5)} !important;
      background: #fff !important;
    }
    .disabledItems {
      padding-top: ${pxToRem(2)};
      &:empty {
        display: none;
      }
      .itemContainer > .ui.checkbox > label {
        color: #999;
      }
    }
  }
`;

export const StyledDraggable = styled(DragAndDropList.Draggable)`
  &&& {
    background: transparent;
    padding: 0;
    margin: ${pxToRem(2)} 0;
    outline: none;
    &.dragging {
      position: absolute !important;
      top: unset !important;
      left: unset !important;
    }
  }
`;

export const StyledDroppable = styled(DragAndDropList.Droppable)`
  &&& {
    background: transparent;
    margin-top: 0;
    padding: ${pxToRem(5)} ${pxToRem(10)};
  }
`;

export const ItemContainer = styled.div`
  align-items: center;
  border-radius: ${pxToRem(3)};
  display: flex;
  background: #eff0f0;
  padding: ${pxToRem(7)};
  transition: background 0.2s;
  .handle {
    align-items: center;
    display: flex;
    flex: 1 1 auto;
    justify-content: flex-end;
    opacity: 0.4;
  }
  .toggle .read-only {
    label {
      &:after,
      &:before {
        opacity: 0.4;
      }
    }
  }
  &:hover {
    [draggable] > & {
      background: #eff0f0;
    }
    .handle {
      opacity: 1;
    }
  }
  .items:not(.disabledItems):not(.disabledItemsTop) > .item:active & {
    background: #2e8ece;
    box-shadow: 0 0 ${pxToRem(4)} rgba(0, 0, 0, 0.2);
  }
`;

export const StyledSemanticCheckbox = styled(SemanticUI.Checkbox)`
  &&& {
    margin-left: ${pxToRem(5)};
    &.read-only {
      opacity: 0.75;
    }
  }
`;
